import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { SuiSpinner } from '@splashthat/sui';

const SpinnerContainer = styled.div`
    text-align: center;
`;

const Loader = ({ children, loading }) =>
    loading ? (
        <SpinnerContainer>
            <SuiSpinner />
        </SpinnerContainer>
    ) : (
        children
    );

Loader.propTypes = {
    children: PropTypes.node.isRequired,
    loading: PropTypes.bool,
};

Loader.defaultProps = {
    loading: false,
};

const mapStateToProps = (state) => ({
    loading: state.splashPage.loading,
});

export default connect(mapStateToProps, {})(Loader);
